import axios from 'axios'
import app from '@/main'
import store from '@/store'
import { iPath } from './i18n'
import errorTips from './tips'

axios.defaults.validateStatus = function(status) {
  return status >= 200 && status <= 204 // default
}
const ajax = type => async (
  url,
  data = {},
  { ignoreMsg = false, noToken = false, loading = false } = {},
  ext = { timeout: 10000 }
) => {
  const config = {}
  const token = store.state.token || localStorage.getItem('token')
  if (token && !noToken) {
    config.headers = {
      Authorization: 'Bearer ' + token,
      Authorization_Type: 3
    }
  }
  Object.assign(config, ext)
  config.url = /^https?/.test(url) ? url : CONFIG.api_edu + url
  config.method = type
  if (['put', 'post', 'patch'].includes(type)) {
    config.data = data
  }
  if (type === 'get') {
    config.params = Object.assign({}, data)
    config.params.TIME = +new Date()
  }

  try {
    loadingSwitch(loading)
    const res = await axios(config)
    loadingSwitch(false)
    return res.data
  } catch (error) {
    loadingSwitch(false)
    const response = error.response
    let errorCode
    let errorMessage
    if (response) {
      const data = response.data
      const locale = ['en', 'id', 'it'].includes(store.state.locale)
      const langTips = errorTips[locale ? 'en' : store.state.locale]
      errorCode = data.error_code
      errorMessage =
        data.error_message ||
        data.message ||
        langTips[errorCode] ||
        `未定义错误号 ${errorCode} 的错误提示`
      if (errorCode === 100010) {
        store.commit('LOGOUT')
        app.$router.push(iPath({ name: 'login' }))
      }
    } else {
      errorMessage = error.message
      errorCode = error.status || 0
    }
    if (!ignoreMsg) app.$message.error(errorMessage)
    return Promise.reject({ error_code: errorCode })
  }
}

let loadingInstance
function loadingSwitch(loading) {
  if (loading) {
    loadingInstance = app.$loading({
      lock: true,
      text: loading
    })
  } else {
    if (loadingInstance) loadingInstance.close()
  }
}

export const get = ajax('get')
export const post = ajax('post')
export const put = ajax('put')
export const patch = ajax('patch')
export const del = ajax('delete')
